import { render, staticRenderFns } from "./ReviewHis.vue?vue&type=template&id=9457e834&scoped=true&"
import script from "./ReviewHis.vue?vue&type=script&lang=js&"
export * from "./ReviewHis.vue?vue&type=script&lang=js&"
import style0 from "./ReviewHis.vue?vue&type=style&index=0&id=9457e834&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9457e834",
  null
  
)

export default component.exports